import React from "react";
import { Button } from "react-bootstrap";

type Props = {
    label: string;
    disabled?: boolean;
    onClick: () => void;
};

/**
 * A button that will perform an action when the user clicks on it.
 */
export const ActionButton: React.FC<Props> = (props: Props) => {
    return (
        <div className="col-12">
            <Button variant="primary" onClick={props.onClick} disabled={props.disabled}>
                {props.label}
            </Button>
        </div>
    );
};
